import React,{Component} from 'react';
import { connect } from 'react-redux';
import {mediaPath } from "../../config";

class confirmationScreen extends Component {

	handleLinkClick = (event) => {
		const target = event.target.closest('.try-again a');
		if (target) {
			event.preventDefault();
			this.props.history.push('/login');
		}
	}

	render(){
		return (
           <div className="login-block" onClick={this.handleLinkClick}>
                <div className="login-inner-wrapper">
					<div className="logo"><a onClick={()=>{
										this.props.history.push('/login');
									}} ><img src={mediaPath+"osah-logo.png"} alt="Tax Court Logo" /></a></div>
					<div className="email-sent-section confirmation">
						<h2 className="title">Your new password has been set!</h2>
						<p className="try-again">
              				<a id="loginLink">Log in</a> to access the Public Accesss Platform.
            			</p>
					</div>
                </div>
            </div>
		)
	}
}

export default connect()(confirmationScreen);